import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BasePage } from '../../../shared/base.page';
import { ServiceCaller } from '../../../shared/services/ServiceCaller';
import { UIService } from '../../../shared/services/UIService';
import { DxDataGridComponent, DxValidationGroupComponent } from 'devextreme-angular';
declare let DevExpress: any;

@Component({
    templateUrl: './legislativetypes.page.html'
})

export class LegislativeTypesPage extends BasePage {

    @ViewChild("grid") grid: DxDataGridComponent;
    @ViewChild("frmReset") frmReset: DxValidationGroupComponent; 
    items: any[] = [
        {
            title: "Publish",
            name: "publish",
            icon: "icon-globe",
            showOnRow: false
        },
        {
            title: "Add New",
            name: "addnew",
            icon: "icon-plus",
            showOnRow: false,
            class: "info",
        }
    ]

    searchModel: any = { CountryId: null, State: null, Type: null };
    loadingVisible: boolean = false;
    popupLogVisible: boolean = false;
    popupEditVisible: boolean = false;
    popupEditVisible1: boolean = false;
    log: string = null;
    editRow: any = {};
    countries: any[] = [];
    countries1: any[] = [];
    states: any[] = [];
    types: any[] = [];
    PublishResult: any[] = [];

    constructor(public router: Router, serviceCaller: ServiceCaller, public uiService: UIService) {
        super(serviceCaller);
        serviceCaller.get('/Country/List').then(c => {
            this.countries = c;
            this.countries1 = c;
            this.countries.unshift({ Code: '---', ID: null });
        });
        serviceCaller.get('/LegislativeType/State/List').then(c => {
            this.states = c;
            this.states.unshift({ Title: '---', ID: null });
        });
        serviceCaller.get('/LegislativeType/Type/List').then(c => {
            this.types = c;
            this.types.unshift({ Title: '---', ID: null });
        });
    }


    onMenuItemClick(e) {
        switch (e.name) {
            case "addnew":
                {
                    debugger
                    this.api.get("/LegislativeType/New").then((d) => {
                        this.editRow = {
                            No: d,
                            CountryID: null,
                            IsNew: false,
                            State: null,
                            Type: null,
                            Title: null,
                            Link: null
                        }
                        this.popupEditVisible = true;
                    }).catch(e => { }).then(c => {
                        this.loadingVisible = false;
                    });
                    break;
                }
            case "DXEdit":
                {
                    e.handled = true;
                    let list = this.grid.instance.getSelectedRowKeys();
                    if (list.length) {
                        debugger
                        Object.assign(this.editRow, this.grid.instance.getSelectedRowsData()[0]);
                        this.editRow.IsNew = true;
                        this.popupEditVisible = true;
                    }
                    break;
                }
            case "publish":
                {
                    this.loadingVisible = true;
                    this.api.post("/LegislativeType/Publish").then(data => {
                        debugger
                        if (data) 
                        { 
                            this.PublishResult=data;
                            this.popupEditVisible1 = true; 
                        }
                        else
                        {
                            this.grid.instance.refresh();
                            this.uiService.success();
                        }
                        this.loadingVisible = false;
                    }).catch(e => {
                        this.loadingVisible = false;})
                    ;
                    break;
                }
        }
    }


    save() {
        if (this.frmReset.instance.validate().isValid) {
            this.loadingVisible = true;
            this.api.post("/LegislativeType/Save", this.editRow).then(() => {
                this.grid.instance.refresh();
                this.popupEditVisible = false;
            }).catch(e => { }).then(c => {
                this.loadingVisible = false;
            });
        }

    }

    cancel() {
        this.popupEditVisible = false;
    }

    handleSourceChange() {
        this.grid.instance.refresh();
    }
}



// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/admin/pages/Settings/legislativetypes.page.ts